module.exports = __webpack_public_path__ + "img/py.708150a1.svg";